import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

function LogOutAlert(props) {
    const { heading, para, onClose, onConfirm } = props; // Removed link prop since it's not needed here

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <>
            <Transition appear show={true} as={Fragment}>
                <Dialog as="div" className="relative z-[999999]" onClose={handleClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-md bg-[#e7e7e9] p-4 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                                        {heading}
                                    </Dialog.Title>
                                    <div className="doc-modal flex-col items-center justify-center mt-2">
                                        <div className="text-sm mt-1" style={{ color: "#232345" }}>
                                            {para}
                                        </div>
                                        {/* Buttons below the paragraph */}
                                        <div className="flex space-x-5 mt-4 justify-end"> {/* Add margin to separate from para */}
                                            <button
                                                onClick={onConfirm}
                                                className="bg-gray-400 hover:bg-gray-500 px-5 py-2 rounded"
                                            >
                                                Yes
                                            </button>
                                            <button
                                                onClick={handleClose}
                                                className="bg-[#5959be] hover:bg-[#4b4bde] px-5 py-2 rounded"
                                            >
                                                No
                                            </button>
                                        </div>
                                    </div>

                                    <div className="absolute top-2 right-2"></div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}

export default LogOutAlert;
